/* Salas García · Filtro de precio con deslizador de dos botones (sustituye a los campos Desde/Hasta) + marca de agotados */
(function () {
  function num(t) {
    var n = String(t || '').replace(/[^\d,.]/g, '');
    if (n.indexOf(',') > -1) n = n.replace(/\./g, '').replace(',', '.');
    return parseFloat(n);
  }
  function euro(v) {
    return Math.round(v).toLocaleString('es-ES') + ' €';
  }

  function build(pr) {
    if (pr.querySelector('.sg-pr')) return;
    var ins = pr.querySelectorAll('input[type=text]');
    if (ins.length < 2) return;
    var inLo = ins[0];
    var inHi = ins[1];
    var max = Math.ceil(num(inLo.getAttribute('data-max') || inHi.getAttribute('data-max')));
    if (!(max > 0)) return;
    var lo = inLo.value ? num(inLo.value) : 0;
    var hi = inHi.value ? num(inHi.value) : max;
    lo = Math.max(0, Math.min(lo, max));
    hi = Math.max(lo, Math.min(hi, max));

    var w = document.createElement('div');
    w.className = 'sg-pr';
    w.innerHTML =
      '<div class="sg-pr__v"><span class="sg-pr__lo"></span><span class="sg-pr__hi"></span></div>' +
      '<div class="sg-pr__r"><div class="sg-pr__f"></div>' +
      '<input type="range" class="sg-pr__a" aria-label="Precio mínimo">' +
      '<input type="range" class="sg-pr__b" aria-label="Precio máximo"></div>';
    pr.appendChild(w);

    var a = w.querySelector('.sg-pr__a');
    var b = w.querySelector('.sg-pr__b');
    var f = w.querySelector('.sg-pr__f');
    var tl = w.querySelector('.sg-pr__lo');
    var th = w.querySelector('.sg-pr__hi');
    [a, b].forEach(function (r) {
      r.min = 0;
      r.max = max;
      r.step = 5;
    });
    a.value = lo;
    b.value = hi;

    function paint() {
      var x = +a.value;
      var y = +b.value;
      tl.textContent = euro(x);
      th.textContent = euro(y);
      f.style.left = (100 * x) / max + '%';
      f.style.right = 100 - (100 * y) / max + '%';
      a.style.zIndex = x > max / 2 ? 4 : 2;
    }
    a.addEventListener('input', function () {
      if (+a.value > +b.value) a.value = b.value;
      paint();
    });
    b.addEventListener('input', function () {
      if (+b.value < +a.value) b.value = a.value;
      paint();
    });
    function commit() {
      var x = +a.value;
      var y = +b.value;
      inLo.value = x <= 0 ? '' : String(x);
      inHi.value = y >= max ? '' : String(y);
      inHi.dispatchEvent(new Event('input', { bubbles: true }));
    }
    a.addEventListener('change', commit);
    b.addEventListener('change', commit);
    paint();
  }

  /* Productos agotados: se marcan para atenuarlos (solo si la etiqueta propia del tema dice Agotado; las etiquetas que añade Swatch King no cuentan) */
  function soldOut() {
    document.querySelectorAll('.card-wrapper:not([data-sg-out])').forEach(function (c) {
      var bs = c.querySelectorAll('.card__content .badge');
      for (var i = 0; i < bs.length; i++) {
        if (/agotado|sold out/i.test(bs[i].textContent)) {
          c.setAttribute('data-sg-out', '');
          break;
        }
      }
    });
  }

  function scan() {
    document.querySelectorAll('.mobile-facets__wrapper price-range').forEach(build);
    soldOut();
  }

  function init() {
    scan();
    new MutationObserver(function () {
      scan();
    }).observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
